import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Benefits,
  Values,
  Who,
  Why,
  Audience,
  BuyerPersona,
  GlobalCommunityMap,
  HeroProgramacionDynamic,
  MediaKitsTeaser,
  Metrics,
  PaquetesTeaser,
  AreYouReady,
} from './components';
import landingApiService from '../../../services/landingApi';

const LandingMediaKit = ({ themeMode = 'light' }) => {
  const [landingData, setLandingData] = useState({
    content: [],
    metrics: [],
    pricingOptions: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLandingData = async () => {
      try {
        setLoading(true);
        console.log('🚀 Starting to fetch landing data...');
        const data = await landingApiService.getPublicLandingData();
        console.log('📊 Landing data received:', data);
        setLandingData(data);
        setError(null);
      } catch (err) {
        console.error('❌ Error loading landing data:', err);
        setError('Error al cargar los datos de la landing');
      } finally {
        setLoading(false);
      }
    };

    fetchLandingData();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <div>Cargando...</div>
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <div>Error: {error}</div>
      </Box>
    );
  }

  // Obtener contenido por sección
  const getContentBySection = (section) => {
    return landingData.content.find(item => item.section === section) || {};
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      <Container sx={{ pt: { xs: 2, sm: 3, md: 4 }, pb: 0, overflow: 'hidden' }}>
        <Who themeMode={themeMode} content={getContentBySection('who')} />
      </Container>
      <Container>
        <HeroProgramacionDynamic />
      </Container>
      <Container>
        <Why content={getContentBySection('why')} />
      </Container>
      <Container>
        <Benefits content={getContentBySection('benefits')} />
      </Container>
      <Container>
        <Audience themeMode={themeMode} content={getContentBySection('audience')} />
      </Container>
      <Container>
        <BuyerPersona themeMode={themeMode} content={getContentBySection('buyer-persona')} />
      </Container>
      <Container>
        <GlobalCommunityMap content={getContentBySection('global-community-map')} />
      </Container>
      <Container>
        <Metrics 
          metrics={landingData.metrics}
          content={getContentBySection('metrics')}
        />
      </Container>
      <Container>
        <MediaKitsTeaser />
      </Container>
      <Container>
        <Values content={getContentBySection('values')} />
      </Container>
      <Container>
        <PaquetesTeaser />
      </Container>
      <Container>
        <AreYouReady content={getContentBySection('are-you-ready')} />
      </Container>
    </Box>
  );
};

LandingMediaKit.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default LandingMediaKit;
